/* tslint:disable:max-line-length */
import { FuseNavigationItem } from '@fuse/components/navigation';


const aboutMenuItem : FuseNavigationItem =     {
    id   : 'about',
    title: 'About',
    type : 'basic',
    link : '/m/mft/about',
    exactMatch: true    
};

const homeMenuItem : FuseNavigationItem =     {
    id   : 'home',
    title: 'Home',
    type : 'basic',
    link : '/m/mft',
    exactMatch: true
};

export const defaultNavigation: FuseNavigationItem[] = [
    homeMenuItem,
    aboutMenuItem,

];
export const compactNavigation: FuseNavigationItem[] = [
    homeMenuItem,
    aboutMenuItem,
];
export const futuristicNavigation: FuseNavigationItem[] = [
    homeMenuItem,
    aboutMenuItem,
];
export const horizontalNavigation: FuseNavigationItem[] = [
    homeMenuItem,
    aboutMenuItem,
];
